export const ROUTES = {
  shows: '/shows',
  movies: '/movies',
  search: '/search',
  calendar: '/calendar',
  profile: '/profile',
};

export const ROUTE = {
  movie: '/movie/:id',
  show: '/show/:id',
  person: '/person/:id',
};
